import { GetterTree } from "vuex";
import { ExternalMapLayerState } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<ExternalMapLayerState, RootState> = {
	getExternalMapLayers: state => state.externalMapLayers,
	getExternalMapLayerTypes: state => state.externalMapLayerTypes
};
